export default "__VITE_ASSET__CXf0yfN6__"